<i18n>
  {
    "pt_BR": {
      "default": {
        "title": "Processando o seu pagamento via Paypal",
        "description": "Isto pode demorar algum tempo..."
      },
      "success": {
        "title": "Tudo certo! Pagamento paypal executado!",
        "description": "Agora é só esperar o Paypal nos notificar para liberarmos seus créditos!"
      },
      "error": {
        "title": "Ops, houve algum erro...",
        "description": "Por favor, efetue novamente a compra, se o erro persistir entre em contato."
      }
    }
  }
</i18n>

<template>
  <section class="details">
    <article class="details-card">
      <header class="details-header">
        <h1 class="details-header--title" v-t="prefix + 'title'"></h1>
        <p class="details-header--date" v-t="prefix + 'description'"></p>
      </header>
    </article>
  </section>
</template>

<script>
  import Axios from 'core/axios';

  export default {
    props: {
      invoice: {
        required: true,
      },
    },

    beforeRouteEnter (to, from, next) {
      const { query } = to;

      if (! query.paymentId || ! query.PayerID) {
        return next({
          path: '/invoice',
        });
      }

      next();
    },

    created () {
      this.put();
    },

    computed: {
      prefix () {
        if (this.status === null) {
          return 'default.';
        }

        if (this.status) {
          return 'success.';
        }

        return 'error.';
      },
    },

    data: () => ({
      status: null,
    }),

    methods: {
      put () {
        const { query } = this.$route;

        const data = {
          payment_id: query.paymentId,
          payer_id: query.PayerID,
        };

        Axios.put('invoice/' + this.invoice, data)
          .then(() => this.status = true)
          .catch(() => this.status = false);
      },
    },
  };
</script>



// WEBPACK FOOTER //
// src/components/Invoice/Paypal.vue